export default "__VITE_ASSET__DMeMe5pL__"